import { Badge, Flex, HStack, Text, Button } from '@chakra-ui/react';
import { Mail, ArrowLeftRight } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { ProviderUserRoleColorSchemes } from '@duke-hq/shared-constants/providers';

export function ConsultantBanner({
  firstName,
  lastName,
  email,
  role,
  canChangeConsultant = true,
  onChangeClick,
}: {
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  canChangeConsultant?: boolean;
  onChangeClick: () => void;
}) {
  return (
    <Flex
      w="full"
      gap="10px"
      bg="bg.muted"
      p={2}
      borderRadius="8px"
      mb={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <HStack align="center" color="fg.muted">
        <Flex flexDirection="column">
          <HStack align="center">
            <Text fontWeight="semibold">Enrolling</Text>
            <Text>{`${firstName} ${lastName}`}</Text>
          </HStack>
          <HStack align="center">
            <Mail size="16px" />
            <Text fontSize="sm">{email}</Text>
          </HStack>
        </Flex>
      </HStack>
      <HStack align="end" alignItems="center" gap="10px">
        {role ? (
          <Badge
            borderRadius="full"
            colorScheme={ProviderUserRoleColorSchemes[role] ?? 'gray'}
            variant="muted"
            textTransform="none"
          >
            {role.replace(/_/g, ' ')}
          </Badge>
        ) : null}
        {canChangeConsultant ? (
          <Button size="xs" leftIcon={<ArrowLeftRight size="16px" />} onClick={onChangeClick}>
            <Trans>Change</Trans>
          </Button>
        ) : null}
      </HStack>
    </Flex>
  );
}
